import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMyBilling } from '../../services/billingService';

const PlanComplianceBanner: React.FC = () => {
  const [billing, setBilling] = useState<any>(null);

  useEffect(() => {
    let active = true;
    const refresh = () => getMyBilling().then(result => {
      if (active) setBilling(result);
    }).catch(() => undefined);
    void refresh();
    document.addEventListener('billingComplianceChanged', refresh);
    return () => {
      active = false;
      document.removeEventListener('billingComplianceChanged', refresh);
    };
  }, []);

  const compliance = billing?.compliance;
  if (!compliance?.hasIssue) return null;
  return <div className="shrink-0 border-b border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950" role="status">
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3">
      <div>
        <span className="font-semibold">Some recipes need attention.</span>{' '}
        {compliance.automaticRecipes.suspended > 0 && <span>Kitchen paused {compliance.automaticRecipes.suspended} automatic {compliance.automaticRecipes.suspended === 1 ? 'recipe' : 'recipes'}. </span>}
        {compliance.savedRecipes.excess > 0 && <span>You have {compliance.savedRecipes.current} saved; {billing.plan.name} includes {compliance.savedRecipes.included}. </span>}
      </div>
      <Link to="/account" className="shrink-0 rounded-lg bg-amber-900 px-3 py-2 text-xs font-semibold text-white hover:bg-amber-950">Review recipes and plans</Link>
    </div>
  </div>;
};

export default PlanComplianceBanner;
